import React from "react";

/**
 * Two-option segmented toggle (same UX as Cutie Manual/Automat).
 * value must match one of options[].value
 */
export default function SegmentedToggle({
   name,
   value,
   options = [],
   onChange,
   disabled = false,
   className = "",
   "aria-label": ariaLabel,
}) {
   const list = Array.isArray(options) ? options.filter(Boolean) : [];
   if (list.length < 2) return null;

   const left = list[0];
   const isLeft = String(value) === String(left.value);

   return (
      <div
         className={
            "segmentedToggle" +
            (isLeft ? " segmentedToggle--left" : " segmentedToggle--right") +
            (disabled ? " is-disabled" : "") +
            (className ? ` ${className}` : "")
         }
         role="group"
         aria-label={ariaLabel || name || "Opțiuni"}
      >
         {list.slice(0, 2).map((option) => {
            const checked = String(value) === String(option.value);
            return (
               <label
                  key={String(option.value)}
                  className={
                     "segmentedToggle__option" + (checked ? " is-active" : "")
                  }
               >
                  <input
                     type="radio"
                     name={name}
                     value={option.value}
                     checked={checked}
                     disabled={disabled}
                     onChange={() => onChange?.(option.value)}
                  />
                  <span>{option.label}</span>
               </label>
            );
         })}
      </div>
   );
}
